import { ProposalDecisionMode } from '../model/proposal'

// The canonical order, so the list an author reads never depends on the order
// the settings happen to be stored in.
//
// 'meeting' is deliberately absent: this list holds the ASYNCHRONOUS modes an
// organization opens one by one. Deciding in a meeting is always available and
// is never a setting — it is the fallback the whole feature pushes towards. The
// SQL check org_proposalDecisionModes_valid enforces the same boundary in the
// database, and would reject 'meeting' outright (D6, 06/08/2026).
export const allProposalDecisionModes: ProposalDecisionMode[] = [
  'consent',
  'unanimity',
  'simpleMajority',
  'absoluteMajority',
]

// Which decision modes an author may pick from (D6, 05/08/2026).
//
// The organization opens the modes, one by one. Consent is never removable: it
// is the base mode, and a proposal has to be decidable somehow.
//
// `currentMode` is the mode of a proposal being edited. It stays in the list
// even when the organization has since closed it: one does not change the rules
// of a vote already under way.
export function getOpenProposalDecisionModes(
  orgModes: ProposalDecisionMode[] | undefined,
  currentMode?: ProposalDecisionMode
): ProposalDecisionMode[] {
  return allProposalDecisionModes.filter(
    (mode) =>
      mode === 'consent' || mode === currentMode || !!orgModes?.includes(mode)
  )
}
